import {
  marketingConversationHydratedSchema,
  MarketingConversationPriority,
  MarketingConversationTopic,
  queueCursorSchema,
  QueueType,
} from "@redotech/redo-marketing-common/conversation/marketing-conversation-definition";
import { marketingMessageSchema } from "@redotech/redo-marketing-common/message/marketing-message-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getQueueConversations = {
  name: "getQueueConversations" as const,
  input: z.object({
    limit: z.number(),
    cursor: queueCursorSchema.optional(),
    queueType: createEnum(QueueType).default(QueueType.Default).optional(),
    currentQueueTopic: createEnum(MarketingConversationTopic).optional(),
    priority: createEnum(MarketingConversationPriority).optional(),
  }),
  output: z.object({
    conversations: z.array(marketingConversationHydratedSchema),
    messagesMap: z.record(z.string(), z.array(marketingMessageSchema)),
    total: z.number(),
    nextCursor: queueCursorSchema.nullable(),
  }),
};
